import React, { useEffect } from 'react'
import { View, Text } from 'react-native'
import { formStyles } from './styles'
import { FailureValues } from '../../../../types'
import { useTranslation } from 'react-i18next'

interface Props {
  initialValues?: FailureValues
  getValues: (values: FailureValues) => void
}
export const CategoryThreeFailureForm = ({ getValues }: Props) => {
  const { t } = useTranslation()

  useEffect(() => {
    getValues({
      diver: null,
      noRelief: null,
      hydraulic: null,
      ship: null,
      dotation: null,
      work: null,
    })
  }, [])

  return (
    <View style={formStyles.container}>
      <Text style={formStyles.label}>{t('No hay fallas disponibles para esta categoría')}</Text>
    </View>
  )
}
